import { render } from "./AdministerTokensComponent.vue?vue&type=template&id=7be28478&scoped=true"
import script from "./AdministerTokensComponent.vue?vue&type=script&lang=js"
export * from "./AdministerTokensComponent.vue?vue&type=script&lang=js"

import "./AdministerTokensComponent.vue?vue&type=style&index=0&id=7be28478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be28478"]])

export default __exports__